import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
import simpleParallax from "simple-parallax-js";

// Letters background parallax

const image = document.getElementsByClassName("bg-letters");
new simpleParallax(image, {
  delay: 0,
  orientation: "down",
  scale: 1.5,
  overflow: true,
});

// Menu

const menuButton = document.querySelectorAll(".js-trigger-menu");

menuButton.forEach((element) => {
  element.addEventListener("click", (event) => {
    document.querySelector("body").classList.toggle("is-menu-active");
  });
});

// Header CTA

const ctaButton = document.querySelectorAll(".js-trigger-cta");

ctaButton.forEach((element) => {
  element.addEventListener("click", (event) => {
    document.querySelector("body").classList.toggle("is-cta-active");
  });
});

// Play video

const videoTop = document.querySelector(".video-btn--top");
const video = document.querySelector(".video-full");
const videoPlay = document.querySelector(".video-play");
const videoPause = document.querySelector(".video-pause");
const videoBtnText = document.querySelector(".video-btn-text");

function toggleVideo() {
  if (video.paused || video.ended) {
    video.play();
    if (videoTop) {
      videoBtnText.innerHTML = "Pause video";
    } else {
      document.querySelector(".video-play").classList.add("invisible");
      document.querySelector(".video-pause").classList.remove("invisible");
    }
  } else {
    video.pause();
    if (videoTop) {
      videoBtnText.innerHTML = "Play video";
    } else {
      document.querySelector(".video-pause").classList.add("invisible");
      document.querySelector(".video-play").classList.remove("invisible");
    }
  }
}

if (video) {
  videoPlay.addEventListener("click", toggleVideo);
  videoPause.addEventListener("click", toggleVideo);
}

// Bulletin

const closeBulletin = document.querySelector(".js-bulletin-close");
const bulletin = document.querySelector(".bulletin");

if (bulletin) {
  document.addEventListener("DOMContentLoaded", function () {
    bulletin.style.bottom = "0px";
    document.cookie.split(";").some(function (item) {
      if (item.indexOf("bulletin=closed") >= 0) {
        bulletin.style.bottom = "-500px";
      }
    });
  });

  closeBulletin.addEventListener("click", (event) => {
    document.cookie = "bulletin=closed; path=/";
    bulletin.style.bottom = "-500px";
  });
}

// Counter

const counterTextSectionEl = document.querySelectorAll(".js-trigger-counter");

if (counterTextSectionEl) {
  const handlerCounter = (entries) => {
    if (entries[0].isIntersecting) {
      const counters = document.querySelectorAll(".counter-active");
      const speed = 70;
      counters.forEach((counter) => {
        const updateCounter = () => {
          const target = counter.getAttribute("data-target");
          const count = +counter.innerHTML;
          const score = parseInt(target / speed);

          if (count < target) {
            if (count < 10) {
              counter.innerHTML = count + 1;
              setTimeout(updateCounter, 10);
            } else {
              counter.innerHTML = count + score;
              setTimeout(updateCounter, 10);
            }
          } else {
            counter.innerHTML = target;
          }
        };
        updateCounter();
      });
    } else {
      const counters = document.querySelectorAll(".counter-active");
      counters.forEach((counter) => {
        const updateCounter = () => {
          counter.innerHTML = 0;
        };
        updateCounter();
      });
    }
  };

  counterTextSectionEl.forEach((element) => {
    const observerCounterText = new window.IntersectionObserver(handlerCounter);
    observerCounterText.observe(element);
  });
}

// Featured blogposts slider

const isCarousel = document.querySelector(".js-blogpost-carousel");
if (isCarousel) {
  const blogpostCarousel = tns({
    container: ".js-blogpost-carousel",
    items: 1,
    mouseDrag: false,
    nav: false,
    controls: false,
    speed: 400,
    autoplay: false,
    loop: false,
    responsive: {
      640: {
        items: 1.6,
      },
      1440: {
        items: 3,
      },
    },
  });

  document.querySelector(".prev-blogpost").onclick = () => {
    blogpostCarousel.goTo("prev");

    if (blogpostCarousel.getInfo().index == "0") {
      document.querySelector(".prev-blogpost").classList.add("disabled");
    } else {
      document.querySelector(".next-blogpost").classList.remove("disabled");
    }
  };

  document.querySelector(".next-blogpost").onclick = () => {
    blogpostCarousel.goTo("next");

    if (blogpostCarousel.getInfo().index == "1") {
      document.querySelector(".prev-blogpost").classList.remove("disabled");
    }
    if (
      (blogpostCarousel.getInfo().items == "1" &&
        blogpostCarousel.getInfo().slideCount ==
          blogpostCarousel.getInfo().displayIndex) ||
      (blogpostCarousel.getInfo().items == "1.6" &&
        blogpostCarousel.getInfo().slideCount ==
          blogpostCarousel.getInfo().displayIndex) ||
      (blogpostCarousel.getInfo().items == "3" &&
        blogpostCarousel.getInfo().slideCount - 2 ==
          blogpostCarousel.getInfo().displayIndex)
    ) {
      document.querySelector(".next-blogpost").classList.add("disabled");
    }
  };
}

// Vivistop card hover

const vivistopCard = document.querySelectorAll(".vivistop-card");

vivistopCard.forEach((element) => {
  element
    .querySelector(".js-vivistop-card")
    .addEventListener("mouseover", (event) => {
      element.classList.toggle("vivistop-card--hover");
    });
  element
    .querySelector(".js-vivistop-card")
    .addEventListener("mouseout", (event) => {
      element.classList.toggle("vivistop-card--hover");
    });
});
